<template  lang='pug'>
v-flex(:class="classObj")
  div(v-show="!component.disable")
    .body-2( ref="body2" :align="component.align ? component.align : 'justify'") {{ t(this.id, component.label) }}
</template>

    <script>
      export default {
        name: 'u-zscore',
        props: {
          id: {
            type: String
          },
          component: {
            type: Object,
            required: true
          },
          resultForm: {
            type: Object
          },
          chartData: {}
        },
        watch: {
          chartData: {
            handler: function (val) {
              this.update(val)
            },
            deep: true
          }
        },
        methods: {
          update (payload) {
            if (payload) {
              this.component.disable = false
              const percentil = JSON.parse(JSON.stringify(payload.percentil))
              this.component.label = 'zScore: ' + percentil
              if (percentil >= -2 && percentil <= 2) this.$refs.body2.style.color = 'green'
              else if (percentil < -2 && percentil >= -3) this.$refs.body2.style.color = 'orange'
              else if (percentil > 2 && percentil <= 3) this.$refs.body2.style.color = 'orange'
              else this.$refs.body2.style.color = 'red'
              // this.$refs.body2.style.border = '1px solid black'
              // this.$refs.body2.style.padding = '5px'
              // this.$refs.body2.style.paddingRight = '1px'
            } else {
              this.component.disable = true
            }
          }
        }
      }
    </script>


// WEBPACK FOOTER //
// src/components/form/inputs/Zscore.vue